<template lang="pug">
#editar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.titulo")',
        :voltarPara='true',
        :exibeBotao='false'
    )

    .view-container
        section.editar-contrato-originacao__body
            .editar-contrato-originacao__card
                h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
                el-card(
                    :body-style='{ padding: "20px" }',
                    shadow='never',
                    v-loading='carregando'
                )
                    el-form.col-12(
                        label-position='top',
                        :model='formEdicaoContrato',
                        :rules='formEdicaoContratoRegras',
                        ref='formEdicaoContratoRef'
                    )
                        .row
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                                prop='numeroContrato'
                            )
                                el-input(
                                    disabled,
                                    v-model.number='formEdicaoContrato.numeroContrato',
                                    maxlength='10'
                                )

                            el-form-item.col-2(
                                v-if='isUsuarioLDC',
                                label='Trading',
                                prop='subTrading'
                            )
                                el-select#subTrading(
                                    v-model='formEdicaoContrato.subTrading',
                                    :loading='loading.subTradings',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.subTradings',
                                        :key='id',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-2(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura")',
                                prop='cultura'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.cultura',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ nome, id } in opcoes.culturas',
                                        :key='id + nome',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-2(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra")',
                                prop='safra'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.safra',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ ano, id } in opcoes.safras',
                                        :key='id + ano',
                                        :label='ano',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
                                prop='volumeContratado'
                            )
                                el-input(
                                    v-model='formEdicaoContrato.volumeContratado',
                                    @blur='volumeContratadoFormatado'
                                )
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
                                prop='dataContrato'
                            )
                                el-date-picker#dataContrato(
                                    v-model='formEdicaoContrato.dataContrato',
                                    type='date',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    format='dd/MM/yyyy'
                                )
                        .row
                        
                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.departamento")',
                                prop='departamento'
                            )
                                el-select(
                                    v-model='formEdicaoContrato.departamento',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='{ codigo, nome, id } in opcoes.departamentos',
                                        :key='codigo',
                                        :label='nome',
                                        :value='id'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor")',
                                prop='fornecedor'
                            )
                                el-select(
                                    disabled,
                                    v-model='formEdicaoContrato.fornecedor',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='fornecedor in opcoes.fornecedores',
                                        :key='fornecedor.id + fornecedor.nome',
                                        :label='fornecedor.codigo',
                                        :value='fornecedor'
                                    )

                            el-form-item.col-3(
                                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.ruc")',
                                prop='cnpjFornecedor'
                            )
                                el-select(
                                    disabled,
                                    v-model='formEdicaoContrato.cnpjFornecedor',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    clearable,
                                    filterable
                                )
                                    el-option(
                                        v-for='cnpj in opcoes.cnpjFornecedores',
                                        :key='cnpj',
                                        :label='cnpj',
                                        :value='cnpj'
                                    )
                            el-form-item.col-3.botao
                                el-button(
                                    type='primary',
                                    :disabled='editandoContrato',
                                    @click='salvarEdicao(formEdicaoContrato)'
                                )
                                    i.el-icon.el-icon-plus
                                    | {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';
import FormEmpresaEditarContratoAlvorada from './FormEmpresaEditarContratoAlvorada.vue';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: { BaseHeader, FormEmpresaEditarContratoAlvorada },
    data() {
        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorComPontos'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarSubTrading = (rule, value, callback) => {
            if (this.usuarioLogado?.isLDC && (!value || value === '')) {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }
            callback();
        };

        return {
            formEdicaoContrato: {
                id: '',
                numeroContrato: '',
                departamento: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                dataContrato: '',
                fornecedor: '',
                cnpjFornecedor: '',
                subTrading: ''
            },

            formEdicaoContratoRegras: {
                numeroContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 30,
                        message: this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContratoPY'
                        ),
                        trigger: 'blur'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cnpjFornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                departamento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                subTrading: [
                    {
                        validator: validarSubTrading,
                        trigger: 'change'
                    }
                ]
            },

            opcoes: {
                culturas: [],
                safras: [],
                fornecedores: [],
                cnpjFornecedores: [],
                departamentos: [],
                subTradings: []
            },

            editandoContrato: false,
            carregando: false,
            loading: {
                subTradings: false
            },

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },
    computed: {
        ...mapGetters(['isAlvorada', 'usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDC === true;
        }
    },
    async mounted() {
        this.carregando = true;

        // Primeiro busca os dados para preencher os selects
        await this.buscarDepartamentos();
        await this.buscarCulturas();
        await this.buscarSafras();

        if (this.isUsuarioLDC) {
            await this.buscarSubTradings();
        }

        // Depois que todos os selects estão
        // preenchidos, busca os dados do contrato
        await this.buscarDados();
    },
    methods: {
        convertDate(dataString) {
            const [dia, mes, ano] = dataString.split('/');
            return new Date(`${ano}-${mes}-${dia}T00:00:00`);
        },

        async buscarDados() {
            await ContratoOriginacaoServiceEmpresa.buscarContratoOriginacaoPY(
                this.$route.params.id
            )
                .then(async ({ data }) => {
                    this.formEdicaoContrato = {
                        id: data.dadosContratoOriginacao.id,
                        numeroContrato:
                            data.dadosContratoOriginacao.numeroContrato,
                        cultura: parseInt(
                            data.dadosContratoOriginacao.idMaterial
                        ),
                        safra: parseInt(data.dadosContratoOriginacao.idSafra),
                        volumeContratado:
                            data.dadosContratoOriginacao.volumeContratado,
                        dataContrato: this.convertDate(
                            data.dadosContratoOriginacao.dataContrato
                        ),
                        fornecedor:
                            data.dadosContratoOriginacao.fornecedorParceiroNome,
                        cnpjFornecedor:
                            data.dadosContratoOriginacao.subEmpresaCnpj,
                        departamento:
                            data.dadosContratoOriginacao.localidadeNivelUmId,
                        subTrading: data.dadosContratoOriginacao.subTradingId || ''
                    };
                    setTimeout(() => (this.carregando = false), 500);
                })
                .catch(error => {
                    setTimeout(() => (this.carregando = false), 500);
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },

        async buscarDepartamentos() {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                this.opcoes.departamentos = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async buscarCulturas() {
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarCulturas();

                this.opcoes.culturas = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async buscarSubTradings() {
            try {
                this.loading.subTradings = true;
                const { data } = await ContratoOriginacaoService.buscarSubTradings();
                this.opcoes.subTradings = data;
                this.loading.subTradings = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSubTrading'
                    )
                );
                this.loading.subTradings = false;
            }
        },

        salvarEdicao() {
            this.$refs['formEdicaoContratoRef'].validate(async valid => {
                if (valid) {
                    this.editandoContrato = true;
                    this.carregando = true;
                    const payload = {
                        id: this.formEdicaoContrato.id,
                        numeroContrato: this.formEdicaoContrato.numeroContrato,
                        idMaterial: this.formEdicaoContrato.cultura,
                        idSafra: this.formEdicaoContrato.safra,
                        volumeContratado: parseFloat(
                            this.formEdicaoContrato.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        dataContrato:
                            this.formEdicaoContrato.dataContrato.getTime(),
                        fornecedorParceiroId: this.formEdicaoContrato.id,
                        ruc: this.formEdicaoContrato.cnpjFornecedor,
                        localidadeNivelUmId:
                            this.formEdicaoContrato.departamento
                    };

                    if (this.isUsuarioLDC && this.formEdicaoContrato.subTrading) {
                        payload.idContratoOriginacaoSubTrading = this.formEdicaoContrato.subTrading;
                    }

                    ContratoOriginacaoServiceEmpresa.editarContratoPY(payload)
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                                ) +
                                    ' ' +
                                    this.formEdicaoContrato.numeroContrato +
                                    ' ' +
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoAlterado'
                                    )
                            );
                            this.redirecionar();
                        })
                        .catch(error => {
                            if (
                                error.response.status === 405 ||
                                error.response.status === 400
                            ) {
                                this.$notify.error({
                                    message: error.response.data.message
                                });
                            } else {
                                this.$notify.error(
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroEditarContrato'
                                    )
                                );
                            }
                        })
                        .finally(() => {
                            this.carregando = false;
                        });
                } else {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }
            });
        },
        volumeContratadoFormatado() {
            this.formEdicaoContrato.volumeContratado =
                formatters.formatarTonelada(
                    this.formEdicaoContrato.volumeContratado
                );
        },
        redirecionar() {
            this.editandoContrato = false;
            this.$router.push({ path: '/rastreabilidade/empresa' });
        }
    }
};
</script>

<style lang="scss">
#editar-contrato-originacao {
    .editar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }
    .el-form-item__content {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        width: 100%;
    }
    .editar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }

        .el-card {
            border-radius: 15px;
        }

        .el-collapse-item {
            border-radius: 10px;
            overflow: hidden;
        }

        .el-collapse-item__content {
            padding: 0px;
        }

        .el-form-item {
            padding: 0 4px;
        }

        .el-select,
        .el-input,
        .el-date-picker,
        .el-button {
            width: 100%;
        }

        .row {
            align-items: flex-end;
            margin-bottom: 15px;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label::before,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:before {
            content: none !important;
            margin-right: 0px !important;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label:after,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:after {
            content: '*';
            color: #f56c6c;
            margin-left: 4px;
        }
    }
    .el-form-item.col-3.botao {
        display: flex;
        align-items: flex-end;
        justify-content: left;
    }
}
</style>
